import { render, staticRenderFns } from "./AdvanceSignatory.vue?vue&type=template&id=55473cbc"
import script from "./AdvanceSignatory.vue?vue&type=script&lang=js"
export * from "./AdvanceSignatory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports